import { Injectable } from '@angular/core';
import { Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { WebService } from '../web.service';
import { CustomerGuideJustification } from '../../class/customer-guide-justification';

@Injectable()
export class CustomerGuideJustificationService extends WebService {

    public getCustomerGuideJustification (id: number, page?: number, per_page?: number, sort?: string, query?: string, filters?: any[]): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (page !== null && page !== undefined) {
            params.append('_page', String(page));
        } else {
            params.append('_page', '1');
        }

        if (per_page !== null && per_page !== undefined) {
            params.append('_limit', String(per_page));
        } else {
            params.append('_limit', '10');
        }

        if (sort !== null && sort !== undefined) {
            params.append('_sort', String(sort));
        }

        if (query !== null && query !== undefined && query !== '') {
            params.append('_q', String(query));
        }

        if (filters !== null && filters !== undefined && filters.length > 0) {
            filters.forEach(element => {
                params.append(element.key, String(element.value));
            });
        }

        params.append('_with', String('user.employee'));

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/customer-guide-justification?${id}`, options);
    }

    public getCustomerGuideJustificationByEvent(id: number, id_customer_guide: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/customer-guides/${id_customer_guide}/customer-guide-justification?id=${id}`,  { headers: this.headers } );    }

    public newCustomerGuideJustification(id: number, body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/customer-guides/${id}/customer-guide-justification`, JSON.stringify(body) , { headers: this.headers } );
    }

    public updateCustomerGuideJustification(id: number, body: Object): Observable<Response> {
        return this.http.patch( `${this.apiUrl}/customer-guide-justification/${id}`, JSON.stringify(body) , { headers: this.headers } );
    }

    public deleteCustomerGuideJustification(id: number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/customer-guide-justification/${id}`, { headers: this.headers } );
    }

    public infoCustomerGuideJustification(id: number): Observable<Response> {
        return this.http.get( `${this.apiUrl}/customer-guide-justification?id=${id}`,  { headers: this.headers } );
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/customer-guide-justification/customer-guide-justification.service.ts